import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "@/context/ThemeContext"
import { AuthProvider } from "@/context/AuthContext"
import { QueryProvider } from "@/context/QueryProvider"
import { Toaster } from "@/components/ui/toaster"

// Layouts
import RootLayout from "@/layouts/RootLayout"
import AuthLayout from "@/layouts/AuthLayout"
import ProtectedLayout from "@/layouts/ProtectedLayout"

// Pages - Home
import HomePage from "@/pages/HomePage"

// Pages - Auth
import LoginPage from "@/pages/auth/LoginPage"
import SignupPage from "@/pages/auth/SignupPage"
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage"
import AuthCallbackPage from "@/pages/auth/AuthCallbackPage"

// Pages - Main
import ExplorePage from "@/pages/ExplorePage"
import SearchPage from "@/pages/SearchPage"
import PostDetailPage from "@/pages/PostDetailPage"
import CategoryPage from "@/pages/CategoryPage"
import TagPage from "@/pages/TagPage"
import UserProfilePage from "@/pages/UserProfilePage"
import NotFoundPage from "@/pages/NotFoundPage"
import JobsPage from "@/pages/JobsPage"
import JobDetailPage from "@/pages/JobDetailPage"

// Pages - Protected
import DashboardPage from "@/pages/protected/DashboardPage"
import WritePage from "@/pages/protected/WritePage"
import EditPage from "@/pages/protected/EditPage"
import DraftsPage from "@/pages/protected/DraftsPage"
import SavedPage from "@/pages/protected/SavedPage"
import NotificationsPage from "@/pages/protected/NotificationsPage"
import SettingsPage from "@/pages/protected/SettingsPage"
import PostJobPage from "@/pages/protected/PostJobPage"

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange>
        <QueryProvider>
          <AuthProvider>
            <Routes>
              {/* Root layout wraps everything */}
              <Route element={<RootLayout />}>
                {/* Home */}
                <Route path="/" element={<HomePage />} />

                {/* Auth routes with auth layout */}
                <Route element={<AuthLayout />}>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                </Route>

                {/* Auth callback (no special layout) */}
                <Route path="/auth/callback" element={<AuthCallbackPage />} />

                {/* Main routes (no special layout, just root) */}
                <Route path="/explore" element={<ExplorePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/post/:slug" element={<PostDetailPage />} />
                <Route path="/category/:category" element={<CategoryPage />} />
                <Route path="/tag/:tag" element={<TagPage />} />
                <Route path="/user/:username" element={<UserProfilePage />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/jobs/:slug" element={<JobDetailPage />} />

                {/* Protected routes */}
                <Route element={<ProtectedLayout />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/write" element={<WritePage />} />
                  <Route path="/edit/:postId" element={<EditPage />} />
                  <Route path="/drafts" element={<DraftsPage />} />
                  <Route path="/saved" element={<SavedPage />} />
                  <Route path="/notifications" element={<NotificationsPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/post-job" element={<PostJobPage />} />
                </Route>

                {/* 404 catch-all */}
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
            <Toaster />
          </AuthProvider>
        </QueryProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
